"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Variant = exports.Size = exports.Kind = void 0;
var _GlobalKind = _interopRequireDefault(require("../type-tools/GlobalKind"));
var _GlobalSize = _interopRequireDefault(require("../type-tools/GlobalSize"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var Variant = exports.Variant = /*#__PURE__*/function (Variant) {
  Variant["DEFAULT"] = "default";
  Variant["SUBTLE"] = "subtle";
  return Variant;
}(Variant || {});
var Size = exports.Size = function (Size) {
  Size[Size["MEDIUM"] = _GlobalSize["default"].MEDIUM] = "MEDIUM";
  Size[Size["SMALL"] = _GlobalSize["default"].SMALL] = "SMALL";
  return Size;
}(Size || {});
var Kind = exports.Kind = function (Kind) {
  Kind[Kind["DEFAULT"] = _GlobalKind["default"].DEFAULT] = "DEFAULT";
  Kind[Kind["INVERSE"] = _GlobalKind["default"].INVERSE] = "INVERSE";
  return Kind;
}(Kind || {});